import { render, staticRenderFns } from "./FormEditarPerfil.vue?vue&type=template&id=49f9720b"
import script from "./FormEditarPerfil.vue?vue&type=script&lang=js"
export * from "./FormEditarPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports